import { useApplicationStore } from "@/stores/Application";
import { useClearStoreByRoute } from "@/composables/useClearStoreByRoute";
import { type RouteLocationNormalizedLoaded } from 'vue-router';
import { nextTick } from 'vue';
import { linkItems } from "@/components/Header/types/LinkItemsCollection";
import { AppErrorCode } from "@ca.vmedia.tv/domains";
import { UrlPathUtils } from '@/utils';

export default defineNuxtPlugin((nuxtApp) => {
    const { setIsLoadingPageIndicator, checkTimeClearingStorage } = useApplicationStore();
    const { $domains, $router } = useNuxtApp();
    let to: RouteLocationNormalizedLoaded | null = null;
    let from: RouteLocationNormalizedLoaded | null = null;
    
    $router.beforeEach((toPath: RouteLocationNormalizedLoaded, fromPath: RouteLocationNormalizedLoaded) => {
        to = toPath;
        from = fromPath;
    });

    nuxtApp.hook('page:finish', () => {
        void nextTick(() => {
            setIsLoadingPageIndicator(false);
            const schedule = (fn: () => void) =>
                typeof window.requestIdleCallback === 'function' ? window.requestIdleCallback(fn, { timeout: 2000 }) : window.setTimeout(fn, 0);

            schedule(() => {
                $domains.idbCacher.purgeIfQuotaLimit().then((isClearing: boolean) => {
                    if(!isClearing && checkTimeClearingStorage()) {
                        $domains.idbCacher.deleteExpired().then(()=>{
                            console.warn('Expired data deleted by time');
                        }).catch((e: Error) => {
                            console.error(e);
                        });
                    }
                }).catch((e: Error) => {
                    console.error(`Error occurred during IDB cache purge: ${e}`);
                });
            });
        });

        if (to && from) {
            useClearStoreByRoute(to, from);
            to = from = null;
        }
    });

    nuxtApp.hook('app:chunkError', () => {
        void $router.push(UrlPathUtils.buildUrl(linkItems.error.routerPath, {errorCode: AppErrorCode.CHUNK_ERROR}));
    });
});